export default __webpack_public_path__ + "static/media/Postres.23a10cd4.jpg";